import _, { isEmpty } from "lodash";
import { callSDK } from "unifiedring-sdk";
import store from "../../context/store/store";
import { Types } from '../../context/action/action';
import {
    logInfo, toastInformation,
  undoToastInfo,
  initiateAPICall,
  filterContact,
  transcription_On_Off,
  MOM_On_Off,
  callActionChanges,
  noTranscript
  } from "./common";
import { contacts, UserDetails, workContact } from "../../models/model";
import { callFlipData, directnumber, directNumber_Detail } from "../../models/callModel";
import {storeDirectNumber, storeLogs, modifyLogsInput, storeParticularLog, storeCallHistory, storeUndoStep} from "./store_mining";
var undoRun: any;


/**
 * Framing the call,record, voicemail list using company contact
*/
export const leftListFraming =  (listAPI: any, count?: any) => {
  let { logs, logsInput,particularLog }: any = store.getState().callReducer;
  let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let { leftSideWindow } = store.getState().updatedCallList;
  let contactdetail: any = {};
  listAPI.forEach(async (element: any) => {
    if (element.calledNo === element.callingNo && leftSideWindow==='callList') {
      element.userName = loggedUser?.caller_id;
      element.profile_url = loggedUser?.profile_url;
      element.ext = (loggedUser.ext)?.toString();
      element.caller_id = loggedUser?.caller_id;
      element.ImageURL = loggedUser?.profile_url||loggedUser?.profile_image_thumbnail;
      contactdetail = loggedUser;
    }
    else {
      if (leftSideWindow === 'callList') {element.ext = (element.calledNo === loggedUser.ext.toString() ? element.callingNo : element.calledNo);}
      else if (leftSideWindow==='voiceMail') { element.ext = element?.cid_number;}
      else if(leftSideWindow==='recordList'){ element.ext = (element?.from_number === loggedUser.ext.toString() ? element.to_number : element.from_number);  }

        contactdetail = filterContact(element?.ext?.toString());

      if (contactdetail !== undefined) {
        _.merge(element, contactdetail);
      }
      else {
        element.caller_id = element.ext;
        element.ImageURL = '';
        element.department = '';
        element.direct_no = '';
        element.email_id = '';
        element.mobileno = '';
        element.status_msg ="";
        element.user_status = "";
        element.jid = '';
      }
    } 
  });
  let updateDetailPage:Boolean=false;
  updateDetailPage=listAPI.find((latest:any) => {
  if(latest?.ext===particularLog?.ext) return latest
  }
  );
  let conditionVal=leftSideWindow==='callList'?1:0;
  if (logsInput.offset !== conditionVal) { listAPI = logs.concat(listAPI); }
  storeLogs(listAPI); 
  if ((isEmpty(particularLog)&&listAPI !== undefined)) {
      storeParticularLog(listAPI[0],false); }
  else if (!isEmpty(updateDetailPage)&&updateDetailPage!==undefined &&leftSideWindow==='callList'){
    storeParticularLog(updateDetailPage,false)
    getCallHistoryByExt(1);
  }
};

export const incomingCallDetail = (fromExt: string) => {
  let contactReducer: contacts = store.getState().contactReducer || [];
  let companyContact: Array<workContact> = contactReducer.workContacts || [];
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let contactDetail: any = {};
  let dialledNum: string = fromExt.toString();
  if (loggedUserDetails.switchboardNumber === dialledNum) {
    contactDetail['caller_id'] = 'Vectone Mobile'
    return contactDetail;
  }

  else if (dialledNum.length > 3) {
    contactDetail = _.find(companyContact, function (user: any) {
      if (user?.mobileno === dialledNum) {
        return user.mobileno === dialledNum;
      }
      else if (user.direct_no) {
        let directNumber = (user.direct_no).split(",");
        return _.some(directNumber, function (right) {
          return dialledNum === (right.toString()).trim();
        });
      }
    });
  }
  else {
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    if (dialledNum === loggedUserDetails.ext.toString()) {
      return loggedUserDetails;
    }
    else {
      contactDetail = _.find(companyContact, function (o) {
        return (o.ext.toString() === dialledNum)
      });
    }
  }
  return contactDetail || [];
};

// storeFlip old file name
export const callFlipDetail = async() => {
  try {
    new callSDK.CallRestService().getFlipcontactStatus().then((result: callFlipData) => {
      if (result.statusCode === 200) {
        store.dispatch({
          type: Types.GET_CALL_FLIP_DETAIL,
          payloads: result.callFlipRes || []
        });
      }
    })
      .catch((err: any) => { logInfo("callFlipDetail err is", err); });
  }
  catch (error: any) { logInfo("callFlipDetail error", error); }
};

// need to implement the logic
export const recordPermission = async() => {
  try {
    new callSDK.CallRestService().getRecordingstatus().then((result: any) => {
      if (result.statusCode === 200) {
        let recording: any = {};
        recording.automatic_recording = result.isCallRecordingRes.automatic_recording ||
          { inbound: false, outbound: false, is_auto_recording: false };
        recording.ondemand_recording = result.isCallRecordingRes.ondemand_recording || false;
        store.dispatch({
          type: Types.GET_CALL_RECORD_DETAIL,
          payloads: recording
        });
      }
    })
      .catch((err: any) => { logInfo("recordPermission err is", err); });
  }
  catch (error: any) { logInfo("recordPermission error", error); }
};

/**
 * Delete call history using API
*/
export const deleteParticularCallLogs = async (selectedArr: any) => {
  new callSDK.CallRestService().deleteCallHistory(selectedArr).then((result: any) => {
    if (result.statusCode === 200) {
      getCallHistoryByExt(1);
    }
    
    }).catch((err: any) => {
      logInfo("deleteParticularCallLogs err is", err);
      toastInformation("Something went wrong", "failure");
    }); 
};

/**
 * Delete recent logs using API
*/
export const deleteRecentCalls=(selectedArr:any) => {
spliceLogs(selectedArr,'Call')
  undoToastInfo(true,true, false);
  let extList:Array<any>=[],otherList:Array<any>=[];
selectedArr.map((ele: any, index: number) => {ele.length>3?otherList.push(ele):extList.push(ele)});
  undoRun = setTimeout(() => {
    new callSDK.CallRestService().deleteRecentCalls(extList,otherList).then((result: any) => {
    }).catch((err: any) => {
      logInfo("deleteParticularCallLogs err is", err);
      toastInformation("Something went wrong", "failure");
    });
    undoToastInfo(false,false,false);
  }, 5000);
}

/**
 * Delete all recent logs using API
*/

  export const deleteAllRecentCalls = () => {
    spliceAll('Call');
    undoToastInfo(true, true, false);
    toastInformation(`All ${'recent calls'} deleted successfully`, "success");
    undoRun = setTimeout(() => {
      new callSDK.CallRestService().deleteAllRecentCalls().then((data: any) => {
       })
        .catch((err: any) => { logInfo("deleteAllRecentCalls error", err); });
      undoToastInfo(false, false, false);
    }, 5000);
  };


/**
 * clear function for undo 
*/
export const clearUndotimeout = () => {
  let { logsInput,logs,undoStep } = store.getState().callReducer||[];
  let { leftSideWindow } = store.getState().updatedCallList;
  clearTimeout(undoRun);
  toastInformation('Undo Successful', 'success');
  if(logs.length<1 && logsInput.offset !== 0) modifyLogsInput(logsInput.search,leftSideWindow==='callList'?1:0)
  else {modifyLogsInput(logsInput.search,undoStep) }
  initiateAPICall();
  getAllCounts();
};

export const getDirectNumber = async () => {
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let data = {
    "domain_id": loggedUserDetails["domain_id"],
    "company_id": loggedUserDetails["company_id"],
    "number_type": 7,
    "type": 1,
    "extn": loggedUserDetails["ext"]
  };

  new callSDK.CallRestService().getDirectNumber(data).then((result: directNumber_Detail) => {
    if (result?.statusCode === 200) {
      result.direct_number.forEach((element: directnumber) => {
        if (element.assigned_to === 'Switchboard Number') {
          loggedUserDetails['switchboardNumber'] = element.external_number;

          console.log('loggedUserDetails--->>>>>',loggedUserDetails)
          // store.dispatch({
          //   type: Types.ADD_LOGIN,
          //   payload: {
          //     userdetails: loggedUserDetails
          //   }
          // });
        }
      });
      storeDirectNumber(result.direct_number);
    }
  });
};

export const updateDirectNumber = (directNumber:string) => {
  let inputData = {"did_number":directNumber};
  new callSDK.CallRestService().updateDirectNumber(inputData).then((result:any) => {
    let direct_number = store.getState().directNumberDetail.list || [];
     direct_number.map((member: any) => {
        member.is_default=member.external_number === directNumber ?1:0;
    })
    storeDirectNumber(direct_number);
  });
};

/**
 * Delete voicemail using API
*/
export const deleteVoicemail = (list: Array<any>) => {
  spliceLogs(list, 'Voicemail'); 
  undoToastInfo(true, true, false); 
  undoRun = setTimeout(() => {
    new callSDK.CallRestService().multipleVoiceMailDelete(list).then((response: any) => {
    }).catch((err: any) => { logInfo("multipleVoiceMailDelete err is", err); });
    undoToastInfo(false,false,false);
  }, 8000);


};

/**
 * get one to one call logs from the API
*/
export const getCallHistoryByExt = (offset: number) => {
  let { callHistory, particularLog, logs }: any = store.getState().callReducer || [];
  store.dispatch({ 
    type: Types.CALL_HISTORY_LOADING,
    payloads: { isHistoryLoading: false }
  });

  let ext = particularLog && particularLog.ext;
  let isGroupCall:number=particularLog?.serviceType==='GroupCall'?1:0;
  let groupCallId:string=particularLog?.groupId||'';
  
  new callSDK.CallRestService().getCallLogByExt(ext, 25, offset,isGroupCall,groupCallId).then((response: any) => { 
    if (response.statusCode === 200) {

      if (response.getCallHistory.length >= 1 ) {
        return storeCallHistory(offset===1?response.getCallHistory:callHistory?.concat(response.getCallHistory));
      }
      else if (offset===1&&response.getCallHistory.length===0) {    
        let deleteIndex: number;
        deleteIndex = _.findIndex(logs, function (res: any) {
          return ext === res.ext;
        });
        let shiftIndex: number =deleteIndex;
        if (deleteIndex === logs.length - 1) { shiftIndex = 1 }
        logs.splice(deleteIndex, 1);  
        storeCallHistory([]);
        storeParticularLog(logs[shiftIndex],false);
        storeLogs(logs)
      }
      else if(offset!==1&&response.getCallHistory.length===0){
        store.dispatch({ 
          type: Types.CALL_HISTORY_LOADING,
          payloads: { isHistoryLoading: false }
        });
      }
      else {
        store.dispatch({ 
          type: Types.CALL_HISTORY_LOADING,
          payloads: { isHistoryLoading: true }
        });
      }
    }
  })
    .catch((err: any) => { logInfo("getCallList error ", err); });
};

/**
 * Update voicemail read status using API
*/
export function statusVoiceMail(list: any) {
  let { logs,particularLog }: any = store.getState().callReducer||[];

  let flag: string = list.ReadFlag;
  flag = (flag === '0' ? '1' : '0');
  let toast: string = (flag === '1' ? "Read Successfully" : 'Unread Successfully');
  let arr: any = [];
  let uid: any = list.Vm_uuid;
  arr.push(uid);
  new callSDK.CallRestService().readVoiceLog(arr, flag).then((result: any) => {
    if (result.statusCode === 200) {
      _.forEach(logs, function(element: any) {
        if (element.Vm_uuid === list.Vm_uuid) {
          element.ReadFlag = flag;
        }
      });
      storeLogs(logs);
    }
    if (particularLog.Vm_uuid === list.Vm_uuid) {
      particularLog.ReadFlag = flag;
      storeParticularLog(particularLog? particularLog :{},false);
    }
    setTimeout(() => {
      toastInformation( toast, "success");
    },500);
  })
    .catch((err: any) => {
      logInfo('statusVoiceMail err is',err);
    });
}

export const getAsrBasicLang = () => {
  try {
    new callSDK.CallRestService().getAsrLang().then((result: any) => {
      if (result.statusCode === 200) {
        let list:any = [];
        _.forEach(result.asrLanguageList, function(value) {
          let lang = {languageCode:value.languageCode,languageName:value.languageName};
          list.push(lang);
        });
        store.dispatch({
          type: Types.ASR_LANGUAGES,
          payloads: list
        });
      }
    })
      .catch((err: any) => { logInfo("getAsrBasicLang err is", err); });
  }
  catch (error: any) { logInfo("getAsrBasicLang error", error); }

};
export const userUpdateAsrLang = (data:any) => {
  try {
    new callSDK.CallRestService().updateUserAsrLanguage(data).then((data: any) => {
    })
      .catch((err: any) => {
        logInfo("userUpdateAsrLang error",err);      });
  }
  catch (err: any) { logInfo("userUpdateAsrLang error", err); }
};

export const getUserAsrLanguage = () => {
  try {
    new callSDK.CallRestService().getUserAsrLanguage().then((result: any) => {
      if (result.statusCode === 200) {
        store.dispatch({
          type: Types.ASR_MIC_DEFAULT,
          payloads: result.preferanceAsr.preference[0].languageCode || 'en'
        });
      }
    })
      .catch((err: any) => {
        logInfo("error", err);
      });
  }
  catch (err: any) { logInfo("error", err); }
};

/**
 * Delete recordings from the list using API
*/
export const DeleteRecordings = (uuids: any) => {
  spliceLogs(uuids, 'Recorded Calls');
  undoToastInfo(true, true, false);
  undoRun = setTimeout(() => {
    new callSDK.CallRestService().deleteMultiRec(uuids).then((data: any) => { })
      .catch((err: any) => { logInfo("error", err); });
    undoToastInfo(false, false, false);
  }, 5000);
};


export const DeleteAllRecordings = () => {
  spliceAll('Recorded Calls');
  undoToastInfo(true, true, false);
  toastInformation(`All ${'Recorded Calls'} deleted successfully`, "success");
  undoRun = setTimeout(() => {
    new callSDK.CallRestService().deleteAllRecordings().then((data: any) => {
     })
      .catch((err: any) => { logInfo("deleteAllRecordings error", err); });
    undoToastInfo(false, false, false);
  }, 5000);
};


export const DeleteAllVoicemails = () => {
  spliceAll('Voicemail');
  undoToastInfo(true, true, false);
  toastInformation(`All ${'Voicemails'} deleted successfully`, "success");
  undoRun = setTimeout(() => {
    new callSDK.CallRestService().deleteAllVoicemails().then((data: any) => { })
      .catch((err: any) => { logInfo("DeleteAllVoicemails error", err); });
    undoToastInfo(false, false, false);
  }, 5000);
};

/**
 *  get call list from the API
*/
export const getCallLogsCDR = (offset: number, filter: string, search: string) => {
   let { workContacts }: any = store.getState().contactReducer || [];
  //let { logs, particularLog, logsInput } = store.getState().callReducer || [];


  modifyLogsInput(search, offset, filter);  
  new callSDK.CallRestService().getCallLogCDR(25,offset,filter,search).then((response: any) => {
    let { leftSideWindow } = store.getState().updatedCallList;
    if (response.statusCode === 200 && leftSideWindow === 'callList' ) {
      if (workContacts.length === 0) {
        setTimeout(() => {
          let { leftSideWindow } = store.getState().updatedCallList;

          leftSideWindow==='callList'&&leftListFraming(response.result)
        }, 2000)
      }
      else {
         leftListFraming(response.result)
      }
    }
  })
    .catch((err: any) => { logInfo("getCallList error ", err); });
};

/**
 *  get voicemail list from the API
*/
export const getVoiceMailLogs = (offset: number, search: string) => {
  modifyLogsInput(search,offset);
  new callSDK.CallRestService().getVoiceMailList(25, offset, search).then((response: any) => {
    if (response.statusCode === 200) {
      let { leftSideWindow } = store.getState().updatedCallList;
      leftSideWindow==='voiceMail' &&   leftListFraming(response.result)
    }
  })
    .catch((err: any) => { logInfo("getVoiceMailLogs error ", err); });
};


/**
 * get recorded call list from the API
 */
export const getRecordingLogs = (offset: number, search: string) => {
  modifyLogsInput(search,offset);
  new callSDK.CallRestService().getRecordingList(25,offset,search).then((response: any) => {
    if (response.statusCode === 200) {
      let { leftSideWindow } = store.getState().updatedCallList;
      leftSideWindow === 'recordList' && leftListFraming(response.result);
    }
  })
    .catch((err: any) => { logInfo("getRecordingLogs error ", err); });
};


/**
 *  Splicing logs from list
 */
export const spliceLogs = (IDs: Array<any>, name: string) => {
    let { logs, logsInput, particularLog,totalRecordings,totalVoicemails}: any = store.getState().callReducer;
    let { leftSideWindow } = store.getState().updatedCallList;
  let uniqueId = name === 'Voicemail' ? 'Vm_uuid' : name === 'Recorded Calls' ? 'uuid' : 'ext';
  if (logs.length === IDs.length) {
    storeLogs([]);
    storeParticularLog({}, logs.length >= 25 ? true : false);
    storeCallHistory([]);
    toastInformation(`All ${name} deleted successfully`, "success");
    if (logs.length>= 25) {
      modifyLogsInput(logsInput.search, leftSideWindow==='callList'?logsInput.offset + 1:logsInput.offset + 25)
      initiateAPICall();
      storeUndoStep(logsInput.offset);
    }
  }
  else {
    let deleteIndex: number;
    _.forEach(IDs, function (element: any) {
      deleteIndex = _.findIndex(logs, function (res: any) {
        if((element.toString()).length>3&&leftSideWindow==='callList'){
          uniqueId='groupId'
        }
        return res[uniqueId]=== element;
      });
      if (deleteIndex !== undefined && deleteIndex !== -1) {
        if (IDs.includes(particularLog[uniqueId])) {
          let shiftIndex: number =deleteIndex;
          if (deleteIndex === logs.length - 1) { shiftIndex = 0 }

             logs.splice(deleteIndex, 1);
           if(leftSideWindow==='callList')  {storeCallHistory([]);}
          storeParticularLog(logs[shiftIndex],false);
        }
        else {
          logs.splice(deleteIndex, 1);  
        }
        storeLogs(logs);
      }
    });
    toastInformation(`${name} logs deleted successfully`, "success");
    storeUndoStep(logsInput.offset);

  }
  store.dispatch({
    type: Types.TOTAL_COUNTS,
    payloads: {
      totalRecordings:name==='Recorded Calls'?totalRecordings-IDs.length:totalRecordings,
      totalVoicemails: name==='Voicemail'? totalVoicemails-IDs.length:totalVoicemails
    }
  });
}


export const spliceAll=(type:string)=>{
  let { logsInput,totalRecordings,totalVoicemails}: any = store.getState().callReducer;
  storeLogs([]);
  storeParticularLog({}, false);
  storeCallHistory([]);
  storeUndoStep(logsInput.offset);
  store.dispatch({
    type: Types.TOTAL_COUNTS,
    payloads: {
      totalRecordings:type==='Recorded Calls'?0:totalRecordings,
      totalVoicemails: type==='Voicemail'? 0:totalVoicemails
    }
  });
}

/**
 *   Get totalCounts from API
 */

export const getAllCounts = () => {
  new callSDK.CallRestService().getAllCounts().then((response: any) => {
    if (response.statusCode === 200) {
     
      store.dispatch({
        type: Types.TOTAL_COUNTS,
        payloads: {
          totalRecordings:response.callRecCount,
          totalVoicemails: response.voiceMailCount
        }
      });
    }
  })
    .catch((err: any) => { logInfo("getAllCounts error ", err); });
};


/**
 *   Get voicemail Transcript from API
 */

export const voicemailTranscript = () => {
  
  store.dispatch({
    type: Types.ASR_CALLING_FROM,
    payload: {
      asrCallingFrom: 'voiceMail',
      isTranscriptLoading:true
    }
  });

  
   callActionChanges('transcript');
 
};


/**
 *  Get RecordedCall Transcript from API
 */  
export const recordedTranscript = (uuid: string, mode?: any) => {
  store.dispatch({
    type: Types.ASR_CALLING_FROM,
    payload: {
      asrCallingFrom: 'recordList',
      isTranscriptLoading:true
    }
  });
   callActionChanges(mode);
  new callSDK.CallRestService().getRecordingTranscript(uuid).then((response: any) => {
    if (response.statusCode === 200) {
      let isAvailable: any = response?.result[0]?.asrData?.transcript;
      
      if (isAvailable === ''||isAvailable===undefined) noTranscript();
      else {
          store.dispatch({
            type: Types.TRANS_RESULT,
            payload: {
              transAPI: response.result[0].asrData
            }
          });
        if (mode === 'transcript') { return transcription_On_Off(response.result[0].asrData); }
        else return MOM_On_Off(response?.result[0]?.asrData?.translation,'summary')
      }
    }
  })
    .catch((err: any) => { logInfo("getRecordingLogs error ", err); });
};

export const getGroupLogUsers = (groupCallId: any) => {
  let { workContacts }: any = store.getState().contactReducer || [];
  let loggedUser: UserDetails = store.getState().loginReducer.userdetails || [];
  let user :Array<string>=[];
  new callSDK.CallRestService().getCallLogByExt('', 100, 1,1,groupCallId).then((response: any) => { 
    if (response.statusCode === 200) {
      for (var i = 0; i < response.getCallHistory.length; i++) {
        if (response?.getCallHistory[i]?.ext.toString() !== loggedUser?.ext.toString()) {
          let tempuser: any = _.find(workContacts, function (individual: any) {
            return (individual?.ext.toString() === response?.getCallHistory[i]?.ext.toString())
          });
          user.push(tempuser?.sip_login_id);
        }
      }
    }
      }).catch((err: any) => { logInfo("getCallList error ", err); });
    return user;
};